export default "__VITE_ASSET__ejkpKjzS__"